import { ArrowBackIcon, BlueBackIcon } from "assets/images/common/svgs";
import FormErrorMessage from "components/forms/form-error-message";
import useAuth from "containers/auth/useHook";
import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { BAGDE_TYPES, INDUSTRY_TYPES } from "utils/helpers/enums/shared.enum";
import { BadgeDTO } from "utils/helpers/models/badge/badge.dto";
import useBadges from "../../useHooks";
import { warningToaster } from "utils/helpers/common/alert-service";
import { useNavigate } from "react-router-dom";



const CreateEventBadge = () => {
  const [formData, setFormData] = useState<BadgeDTO>(new BadgeDTO());
  const { uploadFile } = useAuth();
  const { createBadge } = useBadges();
  const navigate = useNavigate();
  const {
    register,
    setValue,
    handleSubmit,
    formState: { errors },
  } = useForm<BadgeDTO>();

  const handleFileChange = async (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const { files } = event.target;
    const file = files[0];
    formData.imageUrl = file.name;
    const picture = await uploadFile(file);
    if (picture) {
      formData.imageId = picture.id;
    }
    setFormData({ ...formData });
  };

  const handleChange = (event: any) => {
    const {
      target: { name, value },
    } = event;
    setValue(name, value, { shouldValidate: true });
    setFormData({ ...formData, [name]: value });
  };

  const onSubmit = () => {
    console.log(formData, "formdata");
    if (!formData.imageId) {
      warningToaster("Badge image is required");
    } else {
     createBadge({ ...formData, badgeType: BAGDE_TYPES.EVENT });
    }
  };

  const goToBack = () => {
    navigate(-1);
  };

  return (
    <div className="">
      <h1 className="text-base text-primaryText font-bold flex items-center gap-3">
        <span
          onClick={goToBack}
          className="bg-transparentBlueBg w-[44px] h-[44px] rounded-full flex items-center justify-center cursor-pointer"
        >
          <ArrowBackIcon />
        </span>
        Create a new Badge
      </h1>
      <form onSubmit={handleSubmit(onSubmit)} className="mt-4">

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 items-center">
          {/* Badge Name */}
          {/* <div>
            <label className="block text-base font-semibold text-labelText mb-1">
              Badge Title
            </label>
            <select
              className="w-full h-[51px] border border-lightGrayBorder rounded-lg px-3 py-2 outline-none  "
              {...register("name", { required: true })}
              value={formData.name}
              onChange={handleChange}
            >
              <option value="">Select</option>
              {Object.values(BAGDE_TYPES).map((type, index) => {
                return (
                  <option value={type} key={index} className="capitalize">
                    {type.toLocaleUpperCase()}
                  </option>
                );
              })}
            </select>
            <FormErrorMessage error={errors.badgeType} />
          </div> */}

          <div>
            <label className="block text-base font-semibold text-labelText mb-1">
              Badge Title
            </label>
            <input
              type="text"
              placeholder="Badge Title"
              className="w-full h-[51px] border border-lightGrayBorder rounded-lg px-3 py-2 outline-none"
              {...register("name", { required: true })}
              value={formData.name}
              onChange={handleChange}
            />
            <FormErrorMessage error={errors.name} />
          </div>
          {/* Upload Badge */}
          <div>
            <label className="block text-base font-semibold text-labelText mb-1">
              Upload Badge
            </label>
            <div className="relative flex items-center">
              <label className="bg-gray-200  px-4 py-2 rounded-lg cursor-pointer">
                + Upload
                <input
                  type="file"
                  className="hidden"
                  onChange={handleFileChange}
                />
              </label>
              <span className="ml-2 text-gray-500 text-base">
                {formData.imageUrl ?? "Badge Size: 48 x 48 px"}
              </span>
            </div>
          </div>
          {/* Add Attribute */}
          <div>
            <label className="block text-base font-semibold text-labelText mb-1">
              Industry
            </label>
            <select
              className="w-full h-[51px] border rounded-lg px-3 py-2 outline-none  "
              {...register("industry", { required: true })}
              value={formData.industry}
              onChange={handleChange}
            >
              <option value="">Select</option>
              {Object.values(INDUSTRY_TYPES).map((industry, index) => {
                return (
                  <option value={industry} key={index} className="capitalize">
                    {industry.replaceAll("_", " ").toLocaleUpperCase()}
                  </option>
                );
              })}
            </select>
            <FormErrorMessage error={errors.industry} />
          </div>
          {/* <div>
            <label className="block text-base font-semibold text-labelText mb-1">
              Registration Duration
            </label>
            <select
              className="w-full border border-lightGrayBorder rounded-lg px-3 py-2 outline-none  "
              {...register('criteria.registrationDuration', {required: true})}
              value={formData.criteria.registrationDuration}
              onChange={handleCriteriaChange}
            >
              <option value="">Select</option>
              {regDurationOptions.map((option,index) => {
                return <option value={option.title} key={index}>{option.title}</option>
              })}
            </select>
            <FormErrorMessage error={errors?.criteria?.registrationDuration}/>
          </div> */}
          {/* <div>
            <label className="block text-base font-semibold text-labelText mb-1">
              Event Count
            </label>
            <input
              className="w-full border border-lightGrayBorder rounded-lg px-3 py-2 outline-none  "
              type="number"
              {...register('criteria.eventCount', {min: {value: 1, message: 'Event count should atleast be 1'}})}
              value={formData.criteria.eventCount}
              onChange={handleCriteriaChange}
            />
            <FormErrorMessage error={errors?.criteria?.eventCount}/>
          </div> */}
          {/* <div>
            <label className="block text-base font-semibold text-labelText mb-1">
              For Role
            </label>
            <select
              className="w-full border border-lightGrayBorder rounded-lg px-3 py-2 outline-none  "
              {...register('criteria.forRole')}
              value={formData.criteria.forRole}
              onChange={handleCriteriaChange}
            >
              <option value="">Select</option>
              {Object.values(ROLES).map((role,index) => {
                return <option value={role} key={index}>{role.replaceAll('_', ' ')}</option>
              })}
            </select>
            <FormErrorMessage error={errors?.criteria?.forRole}/>
          </div> */}
        </div>
        {/* Save Button */}
        <div className="mt-6">
          <button
            className="bg-darkSlateBlueBg text-white px-6 py-2 rounded-lg "
            type="submit"
          >
            Save
          </button>
        </div>
      </form>
    </div>
  );
};

export default CreateEventBadge;
